const RELOAD_QUERY_PARAM = "__app_reload";
const CHUNK_RELOAD_BUILD_KEY = "chunk_reload_build";

const normalizeScriptUrl = (src) => {
  if (!src) return "";
  return new URL(src, document.baseURI).href;
};

export const getRunningBuildFingerprint = () => {
  // Read the bundle this page actually loaded, not a manifest from a newer deploy.
  const mainScript = Array.from(document.scripts).find((script) =>
    /\/static\/js\/main\.[^/]+\.js$/.test(new URL(script.src || document.baseURI).pathname),
  );
  return mainScript ? normalizeScriptUrl(mainScript.src) : "";
};

export const getManifestBuildFingerprint = (manifest) =>
  normalizeScriptUrl(manifest?.files?.["main.js"]);

export const shouldAutoReloadChunk = () => {
  const build = getRunningBuildFingerprint() || "unknown-build";
  try {
    // One attempt per loaded build in this tab, even if the next load is slow.
    if (sessionStorage.getItem(CHUNK_RELOAD_BUILD_KEY) === build) return false;
    sessionStorage.setItem(CHUNK_RELOAD_BUILD_KEY, build);
    return true;
  } catch {
    // Without persistent loop protection, leave recovery to the user's button.
    return false;
  }
};

export const reloadForUpdate = ({ home = false } = {}) => {
  const url = new URL(home ? "/" : window.location.href, window.location.origin);
  // A different document URL avoids reusing a stale cached app shell.
  url.searchParams.set(RELOAD_QUERY_PARAM, `${Date.now()}-${Math.random().toString(36).slice(2)}`);
  window.location.replace(url.href);
};

export const clearUpdateReloadParam = () => {
  const url = new URL(window.location.href);
  if (url.searchParams.has(RELOAD_QUERY_PARAM)) {
    url.searchParams.delete(RELOAD_QUERY_PARAM);
    window.history.replaceState(window.history.state, "", url.href);
  }
};
